module.exports = __webpack_public_path__ + "static/media/dec-vertical-id-front.2ace20bd.gif";